(function(){
var dialog=document.getElementById('lp-promo');
if(!dialog||!dialog.showModal||dialog.dataset.lpInitialized)return;
dialog.dataset.lpInitialized='true';
var lip=dialog.querySelector('.lp-lip'),teeth=dialog.querySelector('.lp-teeth'),soundButton=(function(){var b=document.createElement('button');b.type='button';b.className='lp-welcome-sound';b.textContent=({fr:'Écouter le message',en:'Listen to the welcome',es:'Escuchar la bienvenida',ar:'استمع إلى رسالة الترحيب'})[dialog.dataset.locale]||'Écouter le message';b.style.cssText='position:relative;z-index:2;margin:12px auto;padding:12px 20px;background:#1D6C12;color:white;border:0;border-radius:24px;font:inherit;cursor:pointer';b.addEventListener('click',function(){if(!canSpeak&&!dialog.dataset.welcomeAudio)return;stopped=false;clearTimeout(closeTimer);speakWelcome();});dialog.appendChild(b);return b;})(),welcomeAudio=null;
var canSpeak=typeof window.speechSynthesis!=='undefined'&&typeof window.SpeechSynthesisUtterance!=='undefined';
var mouthTimer=0,stopped=true,utterance=null,speechStarted=false,greetingShown=true,closeTimer=0;
var welcomeLine=dialog.dataset.welcomeLine,welcomeLocale=dialog.dataset.locale;
var shapes=['M2 6 Q34 28 66 6 Q58 30 34 30 Q10 30 2 6Z','M5 5 Q34 13 63 5 Q62 31 34 31 Q6 31 5 5Z','M17 5 Q34 0 51 5 Q59 30 34 31 Q9 30 17 5Z','M4 9 Q34 16 64 9 Q54 22 34 22 Q14 22 4 9Z'];
function mouth(shape){if(!lip||!teeth)return;lip.setAttribute('d',shapes[shape]);lip.setAttribute('fill',shape===0?'#81cc7a':'#78390b');teeth.setAttribute('opacity',shape===1?'1':'0');}
function animateSpeech(){
clearInterval(mouthTimer);var n=0;mouth(1);
mouthTimer=setInterval(function(){mouth([1,2,3,1,0,2,1,3][n++%8]);},120);
}
function finishSpeech(autoClose){clearInterval(mouthTimer);mouth(0);dialog.classList.remove('is-speaking');if(autoClose&&dialog.open){clearTimeout(closeTimer);closeTimer=setTimeout(function(){if(dialog.open)dialog.close();},700);}}
function speakWelcome(){
if(welcomeLocale==='ar'&&dialog.dataset.welcomeAudio){
if(welcomeAudio){welcomeAudio.pause();welcomeAudio.currentTime=0;}
if(canSpeak)window.speechSynthesis.cancel();
welcomeAudio=new Audio(dialog.dataset.welcomeAudio);
welcomeAudio.preload='auto';
welcomeAudio.playbackRate=1.18;
speechStarted=false;
if(soundButton)soundButton.hidden=false;

welcomeAudio.onplay=function(){speechStarted=true;if(soundButton)soundButton.hidden=true;dialog.classList.add('is-speaking');animateSpeech();};
welcomeAudio.onended=function(){finishSpeech(true);};
welcomeAudio.onerror=function(){finishSpeech();clearTimeout(closeTimer);if(soundButton)soundButton.hidden=false;};
var playback=welcomeAudio.play();
if(playback&&playback.catch)playback.catch(function(){finishSpeech();clearTimeout(closeTimer);if(soundButton)soundButton.hidden=false;});
return;
}
if(soundButton)soundButton.hidden=true;speechStarted=false;
if(!canSpeak){if(soundButton)soundButton.hidden=false;clearTimeout(closeTimer);finishSpeech();return;}
window.speechSynthesis.cancel();
var spokenLine=welcomeLine.replace(/LIVPACK/gi,'Livpack');
if(welcomeLocale==='ar')spokenLine=spokenLine.replace('ليف باك','ليفباك');
utterance=new window.SpeechSynthesisUtterance(spokenLine);
utterance.lang=welcomeLocale==='fr'?'fr-FR':welcomeLocale==='ar'?'ar':welcomeLocale==='es'?'es-ES':'en-US';utterance.rate=1.02;utterance.pitch=1.05;
var requestedLang=utterance.lang.toLowerCase(),voicePrefix=requestedLang.slice(0,2);
utterance.onstart=function(){speechStarted=true;if(soundButton)soundButton.hidden=true;dialog.classList.add('is-speaking');animateSpeech();};
utterance.onboundary=function(){mouth(Math.random()>.5?1:2);};
utterance.onend=function(){finishSpeech(true);};
utterance.onerror=function(){finishSpeech();clearTimeout(closeTimer);if(soundButton)soundButton.hidden=false;}
var speechQueued=false,voiceWaitStarted=Date.now(),voiceWaitTimer;
function startUtterance(){
if(speechQueued)return;
if(!dialog.open||stopped){speechQueued=true;clearTimeout(voiceWaitTimer);if(window.speechSynthesis.removeEventListener)window.speechSynthesis.removeEventListener('voiceschanged',startUtterance);return;}
var voices=window.speechSynthesis.getVoices();
if(!voices.length&&Date.now()-voiceWaitStarted<1400&&!(navigator.userActivation&&navigator.userActivation.isActive))return;
speechQueued=true;clearTimeout(voiceWaitTimer);
if(window.speechSynthesis.removeEventListener)window.speechSynthesis.removeEventListener('voiceschanged',startUtterance);
var voice=voices.find(function(v){return v.lang.toLowerCase()===requestedLang;})||voices.find(function(v){return v.lang.toLowerCase().slice(0,2)===voicePrefix;});
if(voice)utterance.voice=voice;
window.speechSynthesis.speak(utterance);
}
if(window.speechSynthesis.addEventListener)window.speechSynthesis.addEventListener('voiceschanged',startUtterance);
voiceWaitTimer=setTimeout(startUtterance,1450);
startUtterance();
setTimeout(function(){if(!speechStarted&&dialog.open&&greetingShown&&soundButton)soundButton.hidden=false;},2500);
}

function stop(){
stopped=true;clearTimeout(closeTimer);
if(welcomeAudio){welcomeAudio.pause();welcomeAudio.currentTime=0;}
if(canSpeak)window.speechSynthesis.cancel();
finishSpeech();
}
function close(){stop();if(dialog.open)dialog.close();}
function open(){
if(dialog.open||document.hidden||(window.Shopify&&window.Shopify.designMode))return;
stopped=false;dialog.classList.add('is-welcome');dialog.showModal();
clearTimeout(closeTimer);
speakWelcome();
}
dialog.querySelector('.lp-promo-close').addEventListener('click',close);var welcomeGestureUsed=false;document.addEventListener('click',function(e){if(!e.isTrusted||welcomeGestureUsed||!dialog.open||stopped||speechStarted||e.target.closest('.lp-promo-close,.lp-welcome-sound'))return;welcomeGestureUsed=true;clearTimeout(closeTimer);speakWelcome();});
dialog.addEventListener('close',stop);
window.addEventListener('pagehide',close);
window.addEventListener('pageshow',function(event){if(event.persisted)close();});
document.addEventListener('visibilitychange',function(){if(document.hidden)close();});
if(canSpeak)window.speechSynthesis.getVoices();
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',open,{once:true});else open();
})();